import BreadcrumbWithLink from "components/Common/BreadcrumbWithLink";
import ConfirmModal from "components/shared-components/ConfirmModal";
import CustomDateFilter from "components/shared-components/RemoteTable/custom-date-filter";
import CustomSelectFilter from "components/shared-components/RemoteTable/custom-select-filter";
import RemoteDataTable from "components/shared-components/RemoteTable/data-table";
import {
  CUSTOM_DATE_FILTER_TABLE_TYPE,
  CUSTOM_SELECT_FILTER_TABLE_TYPE,
  DELAY_FILTER_TIME,
} from "constants/RemoteDataTableContanst";
import { tableFormateDate } from "pages/Error-invoice/utils";
import React, { useEffect, useState } from "react";
import {
  customFilter,
  selectFilter,
  textFilter,
} from "react-bootstrap-table2-filter";
import { useTranslation } from "react-i18next";
import { MetaTags } from "react-meta-tags";
import { useDispatch, useSelector } from "react-redux";
import { useToasts } from "react-toast-notifications";
import { Badge, Button, Card, CardBody, Col, Row } from "reactstrap";
import {
  activeInvoiceSymbol,
  deleteInvoiceSymbol,
  listInvoiceSymbol,
  resetActiveInvoiceSymbol,
  resetDeleteInvoiceSymbol,
  resetListInvoiceSymbol,
  setListInvoiceSymbolColumn,
} from "store/actions";
import { BU_STORE_HEADER } from "store/auth/login/actionTypes";
import DetailInvoiceSymbol from "./DetailInvoiceSymbol";
import {
  KyHieuMauHoaDonMode,
  invoiceSymbolModeList,
  invoiceSymbolRecordStatus,
  invoiceSymbolRecordStatusMode,
  invoiceSymbolType,
} from "./utils";

const ListInvoiceSymbol = props => {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation(["invoiceSymbol"]);
  const { addToast } = useToasts();

  const invoiceSymbol = useSelector(state => state.invoiceSymbol);
  const {
    loadingList,
    errorList,
    list: invoiceSymbolList,

    errorDelete,
    delete: invoiceSymbolDelete,

    errorActive,
    active: invoiceSymbolActive,
  } = invoiceSymbol;

  const [mode, setMode] = useState("");

  const [buCode, setBuCode] = useState("");

  // Detail Invoice Symbol Modal
  const [dataDetail, setDataDetail] = useState({});
  const [detailModal, setDetailModal] = useState(false);

  // Delete Modal
  const [dataDeleteInvoiceSymbol, setDataDeleteInvoiceSymbol] = useState({
    invoiceSymbolId: null,
  });
  const [deleteInvoiceSymbolModal, setDeleteInvoiceSymbolModal] =
    useState(false);

  // Active Modal
  const [dataActiveInvoiceSymbol, setDataActiveInvoiceSymbol] = useState({
    invoiceSymbolId: null,
  });
  const [activeInvoiceSymbolModal, setActiveInvoiceSymbolModal] =
    useState(false);

  const [columnsTable, setColumnsTable] = useState([]);

  useEffect(() => {
    setBuCode(localStorage.getItem(BU_STORE_HEADER) || "");
  }, []);

  const Dashboard = useSelector(state => state.Dashboard);
  const { tenantCodeHeader, finalBuInfo } = Dashboard;

  // Action list chang tenantCode
  useEffect(() => {
    if (finalBuInfo) {
      // Set default value to page|sizePerPage when change Language
      invoiceSymbolList.params.page = 1;
      invoiceSymbolList.params.sizePerPage = 10;
      dispatch(listInvoiceSymbol(invoiceSymbolList.params, true));
    }
  }, [finalBuInfo]);

  // Action list And Change Language
  useEffect(() => {
    initColumn();
    return () => {
      dispatch(resetListInvoiceSymbol());
    };
  }, [dispatch, t]);

  // When Data Use For Table Changed
  useEffect(() => {
    if (invoiceSymbolList) {
      setColumnsTable(initColumns);
    }

    if (invoiceSymbolList.columnsVisible) {
      initColumn();
    }
  }, [invoiceSymbolList]);

  // Action Dispatch
  useEffect(() => {
    if ((invoiceSymbolDelete && invoiceSymbolDelete.success) || errorDelete) {
      if (invoiceSymbolDelete && invoiceSymbolDelete.success) {
        addToast(
          t("message.delete", {
            target: t("invoice_symbol"),
            status: t("message.success"),
          }),
          {
            appearance: "success",
            autoDismiss: true,
          }
        );
      } else if (errorDelete) {
        addToast(
          errorDelete.message ||
            t("message.delete", {
              target: t("invoice_symbol"),
              status: t("message.error"),
            }),
          { appearance: "error", autoDismiss: true }
        );
      }
      dispatch(resetDeleteInvoiceSymbol());
      dispatch(listInvoiceSymbol(invoiceSymbolList.params, true));
    }

    if ((invoiceSymbolActive && invoiceSymbolActive.success) || errorActive) {
      if (invoiceSymbolActive && invoiceSymbolActive.success) {
        addToast(
          t("message.active", {
            target: t("invoice_symbol"),
            status: t("message.success"),
          }),
          {
            appearance: "success",
            autoDismiss: true,
          }
        );
      } else if (errorActive) {
        addToast(
          errorActive.message ||
            t("message.active", {
              target: t("invoice_symbol"),
              status: t("message.error"),
            }),
          { appearance: "error", autoDismiss: true }
        );
      }
      dispatch(resetActiveInvoiceSymbol());
      dispatch(listInvoiceSymbol(invoiceSymbolList.params, true));
    }
  }, [
    addToast,
    dispatch,
    errorActive,
    errorDelete,
    invoiceSymbolActive,
    invoiceSymbolDelete,
    invoiceSymbolList.params,
    t,
  ]);

  // Error Dispatch
  useEffect(() => {
    if (errorList) {
      addToast(errorList.message || t("message.invoice_symbol.list.error"), {
        appearance: "error",
        autoDismiss: true,
      });
      dispatch(resetListInvoiceSymbol());
    }
  }, [addToast, dispatch, errorList, t]);

  const initColumn = () => {
    if (invoiceSymbolList.columnsVisible) {
      for (const item of initColumns) {
        if (invoiceSymbolList.columnsVisible[item.dataField] !== undefined) {
          item.hidden = !invoiceSymbolList.columnsVisible[item.dataField];
        }
      }
    }
    setColumnsTable(initColumns);
  };

  const optionShowColumnHandler = (field, value) => {
    dispatch(setListInvoiceSymbolColumn(field, value));
  };

  const selectOptionsTable = (cell = undefined, name = "", prefix = "") => {
    let options = [];
    const select = {};
    switch (name) {
      case "record_status":
        if (prefix === "invoice_symbol") {
          options = invoiceSymbolRecordStatus;
        }
        break;
      case "isPos":
        options = invoiceSymbolType;
        break;
      default:
        if (cell) {
          return "";
        } else {
          return select;
        }
    }

    // Set option to select with Array values defined
    options.map(item => {
      select[item.key] = t(`table.${name}.${prefix}.${item.key}`);
    });
    // Use For Column Formatter
    if (cell) {
      return select[cell];
    }

    return { ...select };
  };

  const formatOptionsTable = (cell, name = "", prefix = "") => {
    let options = [];
    switch (name) {
      case "record_status":
        if (prefix === "invoice_symbol") {
          options = invoiceSymbolRecordStatus;
        }
        break;
      case "isPos":
        options = invoiceSymbolType;
        break;
      default:
        return "";
    }
    return options.map(
      item =>
        item.key === cell && (
          <Badge
            key={item.key}
            className={`font-size-12 ${item.badgeColor ? item.badgeColor : ""}`}
            pill
          >
            {selectOptionsTable(cell, name, prefix)}
          </Badge>
        )
    );
  };

  const selectOptionFilter = (data = []) => {
    if (data && data.length > 0) {
      return data.map(item => {
        return {
          value: item.id,
          label: `${item.name}`,
        };
      });
    } else {
      return [];
    }
  };

  const handleTableChange = (
    type,
    { page, sizePerPage, sortField, sortOrder, columnFilter }
  ) => {
    invoiceSymbolList.params.sort = sortField
      ? sortOrder + sortField
      : invoiceSymbolList.params.sort;
    invoiceSymbolList.params.columnFilter = columnFilter || {};
    invoiceSymbolList.params.page = page || 1;
    invoiceSymbolList.params.sizePerPage = sizePerPage || 10;
    dispatch(listInvoiceSymbol(invoiceSymbolList.params, true));
  };

  const onSearchAllHandle = value => {
    invoiceSymbolList.params.keywords = value;
    dispatch(listInvoiceSymbol(invoiceSymbolList.params, true));
  };

  const toggleDeleteInvoiceSymbolModal = () => {
    setDeleteInvoiceSymbolModal(!deleteInvoiceSymbolModal);
  };
  const clickDeleteInvoiceSymbolHandler = (row, index) => {
    setDataDeleteInvoiceSymbol({ invoiceSymbolId: row.id });
    toggleDeleteInvoiceSymbolModal();
  };
  const deleteSingleInvoiceSymbolHandler = () => {
    dispatch(deleteInvoiceSymbol(dataDeleteInvoiceSymbol.invoiceSymbolId));
    toggleDeleteInvoiceSymbolModal();
  };

  const toggleActiveInvoiceSymbolModal = () => {
    setActiveInvoiceSymbolModal(!activeInvoiceSymbolModal);
  };
  const clickActiveInvoiceSymbolHandler = (row, index) => {
    setDataActiveInvoiceSymbol({ invoiceSymbolId: row.id });
    toggleActiveInvoiceSymbolModal();
  };
  const activeSingleInvoiceSymbolHandler = () => {
    dispatch(
      activeInvoiceSymbol(dataActiveInvoiceSymbol.invoiceSymbolId, {
        record_status: invoiceSymbolRecordStatusMode.ACTIVE,
      })
    );
    toggleActiveInvoiceSymbolModal();
  };

  const toggleDetailModal = (modeSet = "") => {
    setDetailModal(!detailModal);
    switch (modeSet) {
      case invoiceSymbolModeList.CREATE_INVOICE_SYMBOL_DETAIL:
      case invoiceSymbolModeList.EDIT_INVOICE_SYMBOL_DETAIL:
        dispatch(listInvoiceSymbol(invoiceSymbolList.params, true));
        break;
      default:
        break;
    }
  };

  const clickCreateInvoiceSymbolHandler = (row, index) => {
    setBuCode(localStorage.getItem(BU_STORE_HEADER) || "");
    setDataDetail({ createInvoiceSymbol: true });
    setMode(invoiceSymbolModeList.CREATE_INVOICE_SYMBOL_DETAIL);
    toggleDetailModal();
  };

  const clickEditInvoiceSymbolHandler = (row, index) => {
    setDataDetail({ invoiceSymbolId: row.id });
    setMode(invoiceSymbolModeList.EDIT_INVOICE_SYMBOL_DETAIL);
    toggleDetailModal();
  };

  const selectOptions_khmhdon = () => {
    const result = Object.entries(KyHieuMauHoaDonMode).map(([key, value]) => {
      return {
        value,
        label: `${value} - ${t(`khmhdon_list.${value}`)}`,
      };
    });
    return result;
  };

  const rowEventsHandler = {
    onDoubleClick: (e, row, rowIndex) => {
      setDataDetail({ invoiceSymbolId: row.id });
      setMode(invoiceSymbolModeList.VIEW_INVOICE_SYMBOL_DETAIL);
      toggleDetailModal();
    },
  };

  const listRowAction = [
    {
      icon: <i className="fas fa-pen fa-lg text-primary" />,
      text: t("message.edit", { target: t("invoice_symbol") }),
      onClick: clickEditInvoiceSymbolHandler,
    },
    {
      icon: <i className="fas fa-lock fa-lg text-danger" />,
      text: t("message.delete"),
      conditionVisible: {
        record_status: [invoiceSymbolRecordStatusMode.ACTIVE],
      },
      onClick: clickDeleteInvoiceSymbolHandler,
    },
    {
      icon: <i className="fas fa-lock-open fa-lg text-success" />,
      text: t("message.active"),
      conditionVisible: {
        record_status: [invoiceSymbolRecordStatusMode.INACTIVE],
      },
      onClick: clickActiveInvoiceSymbolHandler,
    },
  ];

  const listMultipleRowAction = [];

  const initColumns = [
    {
      dataField: "bu_code",
      text: t("table.bu_code"),
      sort: true,
      filter: textFilter({
        delay: DELAY_FILTER_TIME,
        placeholder: t("placeholder.enter", {
          title: t("table.bu_code"),
        }),
      }),
    },
    {
      dataField: "khmhdon",
      text: t("table.khmhdon"),
      formatter: (cell, row) => {
        if (
          cell &&
          Object.entries(KyHieuMauHoaDonMode).some(
            ([key, value]) => value === cell
          )
        ) {
          return `${cell} - ${t(`khmhdon_list.${cell}`)}`;
        }

        return cell || "";
      },
      filter: customFilter({
        type: CUSTOM_SELECT_FILTER_TABLE_TYPE,
      }),
      filterRenderer: (onFilter, column) => (
        <CustomSelectFilter
          onFilter={onFilter}
          column={column}
          paramFilter={invoiceSymbolList.params.columnFilter}
          dataSelect={selectOptions_khmhdon()}
          placeholder={t("placeholder.select")}
        />
      ),
    },
    {
      dataField: "khhdon",
      text: t("table.khhdon"),
      sort: true,
      filter: textFilter({
        delay: DELAY_FILTER_TIME,
        placeholder: t("placeholder.enter", {
          title: t("table.khhdon"),
        }),
      }),
    },
    {
      dataField: "is_default",
      text: "Trạng thái sử dụng",
      sort: true,
      formatter: (cell, row) => {
        // "some" return boolean
        return (
          <div className="text-primary fw-bold">{cell === 1 && "Mặc định"}</div>
        );
      },
      filter: selectFilter({
        placeholder: t("placeholder.select", {
          title: "Trạng thái sử dụng",
        }),
        options: {
          1: "Mặc định",
        },
      }),
    },
    {
      dataField: "is_pos",
      text: t("table.isPos.invoice_symbol.name"),
      sort: true,
      filter: selectFilter({
        placeholder: t("placeholder.select", {
          title: t("table.isPos.invoice_symbol.name"),
        }),
        options: selectOptionsTable(undefined, "isPos", "invoice_symbol"),
      }),
      formatter: (cell, row) => {
        // "some" return boolean
        return formatOptionsTable(String(cell), "isPos", "invoice_symbol");
      },
    },
    {
      dataField: "record_status",
      text: t("table.record_status.invoice_symbol.name"),
      sort: true,
      filter: selectFilter({
        placeholder: t("placeholder.select", {
          title: t("table.record_status.invoice_symbol.name"),
        }),
        options: selectOptionsTable(
          undefined,
          "record_status",
          "invoice_symbol"
        ),
      }),
      formatter: (cell, row) => {
        // "some" return boolean
        if (cell && invoiceSymbolRecordStatus.some(item => item.key === cell)) {
          return formatOptionsTable(cell, "record_status", "invoice_symbol");
        } else {
          return ""; // Set Empty If Value Not Match
        }
      },
    },
    {
      dataField: "maker_date",
      text: t("table.maker_date"),
      sort: true,
      hidden: true,
      formatter: (cellContent, row) => tableFormateDate(row.checker_date),
      filter: customFilter({
        type: CUSTOM_DATE_FILTER_TABLE_TYPE,
      }),
      filterRenderer: (onFilter, column) => (
        <CustomDateFilter
          onFilter={onFilter}
          column={column}
          paramFilter={invoiceSymbolList.params.columnFilter}
        />
      ),
    },
    {
      dataField: "maker_id",
      text: t("table.maker_id"),
      hidden: true,
      filter: textFilter({
        delay: DELAY_FILTER_TIME,
        placeholder: t("placeholder.enter", {
          title: t("table.maker_id"),
        }),
      }),
      formatter: (cell, row) => {
        return row.maker && row.maker.display_name
          ? row.maker.display_name
          : cell;
      },
    },
    {
      dataField: "checker_date",
      text: t("table.checker_date"),
      sort: true,
      formatter: (cellContent, row) => tableFormateDate(row.checker_date),
      filter: customFilter({
        type: CUSTOM_DATE_FILTER_TABLE_TYPE,
      }),
      filterRenderer: (onFilter, column) => (
        <CustomDateFilter
          onFilter={onFilter}
          column={column}
          paramFilter={invoiceSymbolList.params.columnFilter}
        />
      ),
    },
    {
      dataField: "checker_id",
      text: t("table.checker_id"),
      filter: textFilter({
        delay: DELAY_FILTER_TIME,
        placeholder: t("placeholder.enter", {
          title: t("table.checker_id"),
        }),
      }),
      formatter: (cell, row) => {
        return row.checker && row.checker.display_name
          ? row.checker.display_name
          : cell;
      },
    },
  ];
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{t("title.list")}</title>
        </MetaTags>
        <div className="container-fluid">
          <BreadcrumbWithLink
            title={t("title.list") + ` (${invoiceSymbolList.totalCount})`}
            breadcrumbItems={[
              { name: t("common:category") },
              { name: t("title.list") },
            ]}
          />

          <Row>
            {/* Modal START*/}
            <Col className="col-12">
              {/* Detail Invoice Symbol Modal */}
              <DetailInvoiceSymbol
                dataDetail={dataDetail}
                isOpenModal={detailModal}
                toggleModal={toggleDetailModal}
                mode={mode}
                buCode={buCode}
              />
              {/* Delete Invoice Symbol Modal */}
              <ConfirmModal
                isOpen={deleteInvoiceSymbolModal}
                titleHeader={t("message.confirm.invoice_symbol.delete.header")}
                titleBody={t("message.confirm.invoice_symbol.delete.body")}
                onConfirm={deleteSingleInvoiceSymbolHandler}
                textBtnConfirm={t("message.agree")}
                textBtnCancel={t("message.cancel")}
                toggle={toggleDeleteInvoiceSymbolModal}
              />
              {/* Active Invoice Symbol Modal */}
              <ConfirmModal
                isOpen={activeInvoiceSymbolModal}
                titleHeader={t("message.confirm.invoice_symbol.active.header")}
                titleBody={t("message.confirm.invoice_symbol.active.body")}
                onConfirm={activeSingleInvoiceSymbolHandler}
                textBtnConfirm={t("message.agree")}
                textBtnCancel={t("message.cancel")}
                toggle={toggleActiveInvoiceSymbolModal}
              />
            </Col>
            {/* Modal E N D*/}
            <Col className="col-12">
              <Card>
                <CardBody>
                  <RemoteDataTable
                    // selectRow={selectRowCheckbox}
                    keyField="id"
                    data={invoiceSymbolList.items}
                    columns={columnsTable}
                    page={invoiceSymbolList.params.page}
                    sizePerPage={invoiceSymbolList.params.sizePerPage}
                    totalSize={invoiceSymbolList.totalCount}
                    onTableChange={handleTableChange}
                    onSearchAllHandle={onSearchAllHandle}
                    optionShowColumnHandel={optionShowColumnHandler}
                    rowEvents={rowEventsHandler}
                    listMultipleRowAction={listMultipleRowAction}
                    listRowAction={listRowAction}
                    loading={loadingList}
                  >
                    <Button
                      color="primary"
                      className="btn-label"
                      onClick={clickCreateInvoiceSymbolHandler}
                    >
                      <i className="fas fa-plus label-icon" />
                      {t("title.create")}
                    </Button>
                  </RemoteDataTable>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ListInvoiceSymbol;
